import { parseAmount } from '../../../Commerce/PaymentCreator/src/paycentral.helper.payment.js';

window.Asi = window.Asi || {};
window.Asi.PayCentral = window.Asi.PayCentral || {};

window.Asi.PayCentral.DonationCreatorClient = {
    initialize({ initialAmount }) {
        let storedAmount = initialAmount ?? 0;

        window.Asi.PayCentral.ClientManager.initialize({
            getAmountValue: () => storedAmount,
            setAmountValue: (val) => {
                const parsed = parseAmount(val);
                storedAmount = parsed != null ? parsed : 0;
            }
        });

        window.Asi.PayCentral.ClientManager.setAmount(storedAmount);
    }
};